import { InstructionComponentProps } from "../InstructionComponent"

const DeregisterReportsInstruction: InstructionComponentProps = {
    name: "Wie kann ich die wöchentlichen Berichte für einen Patienten deaktivieren?",
    path: "/help/professional/deregister_reports",
    description: (
        <>
            <p className="mb-4">
                Sie können die automatischen wöchentlichen Berichte für einen Patienten deaktivieren, 
                indem Sie eine Notiz mit dem genauen Text <strong>"STUDIE BEENDET"</strong> oder 
                <strong>"DROPOUT"</strong> erstellen.
            </p>
            <p className="mb-4">
                <strong>Wichtig:</strong> Der Text muss exakt so geschrieben werden (Großbuchstaben), 
                damit das System die Notiz erkennt und die Berichte deaktiviert.
            </p>
            <p className="mb-4">
                <strong>So gehen Sie vor:</strong>
            </p>
            <ol className="list-decimal list-inside space-y-2 mb-4">
                <li>Navigieren Sie zur Patientenübersicht und wählen Sie den entsprechenden Patienten aus.</li>
                <li>Sie finden dort die Notizen-Funktion, direkt unterhalb der Kachel 'Bericht-Auswahl'. </li>
                <li>Erstellen Sie eine neue Notiz mit dem exakten Text <strong>"STUDIE BEENDET"</strong> 
                    (für Studienende) oder <strong>"DROPOUT"</strong> (für Dropouts).</li>
                <li>Speichern Sie die Notiz durch einen Klick auf das grüne Feld 'Hinzufügen'.</li>
            </ol>
            <p className="mb-4">
                Nach dem Erstellen der Notiz werden keine weiteren wöchentlichen Berichte für diesen 
                Patienten per E-Mail versendet.
            </p>
            <p className="mb-4">
                <strong>Hinweis:</strong> Wenn Sie die Notiz später überschreiben oder löschen, 
                werden die Berichte automatisch wieder aktiviert.
            </p>
        </>
    )
}

export default DeregisterReportsInstruction

